import styled from '@emotion/styled';

export const WrapperStep = styled.section`
  // overflow: ${props => (props.isAnimating ? 'hidden' : 'visible')};
  height: ${props => (props.isAnimating ? '400px' : 'auto')};
  position: relative;
  z-index: 1;
  transform: translateZ(0);
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;
`;


export const ContainerModal = styled.div`

  background: #fff;
    border-radius: 3px;
    width: 339.4px;
    padding-bottom: 20px;
    padding-left: 5px;
    padding-right: 5px;
`;



export const SectionModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContenedorIconos = styled.div`
  margin-top: 28px;
`;

export const Icono = styled.img`
  width: 50px;
  height: 50px;
`;

export const IconoCerrar = styled.i`
  position: relative;
  top: -50px;
  left: 145px;
  cursor: pointer;
  color: #383D43;
 
`;

export const IconoCerrarInactiva = styled.i`
  position: relative;
  top: -50px;
  left: 145px;
  cursor: pointer;
  font-size: 20px;
`;

export const TituloModal = styled.h2`

    font-size: 15px;
    text-align: center;
    font-weight: 400;
    margin-bottom: 5px;
    margin-top: 5px;
    color: #000;
    width: ${props => (props.isError ? '60%' : 'auto')};
    font-family: 'Poppins', sans-serif;
  
`;

export const SubtituloModal = styled.h3`

  font-size: 14px;
  text-align: center;
  font-weight: 400;
  width: 275px;
  color: #000;
  font-family: 'Poppins', sans-serif;
`;

export const ContenedorConfronta = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContenedorPregunta = styled.div`
  width: 95%;
  // height: 210px;
`;

export const Pregunta = styled.h2`
  font-size: 13.5px;
  font-weight: 700;
  color: #000;
  font-family: 'Poppins', sans-serif;
`;

export const TextoModalInactivo = styled.h2`
  font-size: 13.5px;
  // font-weight: 700;
  color: #23272B;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  line-height: 18px;
`;

export const CodigoOTP = styled.h2`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #23272B;
  font-family: 'Poppins', sans-serif;
  text-align: center;
`;

export const OtpInput = styled.input`
  width: 35px;
  height: 35px;
  font-size: 1rem;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin: 0 4px;
  outline: none;
  transition: border 0.2s;
  background: #fff;

  &:focus {
    border: 1.5px solid #0097cf;
    background: #f0faff;
  }

  &:disabled {
    background: #f5f5f5;
    color: #bbb;
    border: 1px solid #eee;
  }
`;

export const OtpTimer = styled.div`
  margin-bottom: 12px;
  color: #23272B;
  font-weight: bold;
  font-size: 1.1rem;
  text-align: center;
  letter-spacing: 1px;
`;

export const ReenviarCodigo = styled.div`
  h2 {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  color: #CACACA;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  cursor: pointer;
  }

`;

export const ContenedorRespuestas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px; 
  width: 100%;

`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border : 1px solid #D9D9D9;
  border-radius: 5px;
  padding: 5px;
`;

export const RadioInput = styled.input`
  display: none;

  &:checked + span::after {
    opacity: 1;
  }
`;

export const RadioCircle = styled.span`
  width: 16.8px;
  height: 16.8px;
  border-radius: 50%;
  border: 2px solid #666;
  margin-right: 10px;
  margin-left: 8px;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 9px;
    background: #000000;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s;
  }
`;

export const RadioLabel = styled.span`
  font-size: 13.4px;
  color: #000; 
  font-weight: 400;
  line-height: 1.5;
  font-family: 'Poppins', sans-serif;
`;

export const ContenedorBoton = styled.div`
  display: flex; 
  gap: 10px;
  width: 95%;
  margin-top: 5px;
`;

export const Boton = styled.button`
  width: 100%;
  height: 45px;
  background-color: #377CAC;
  text-align: center;
  color: #ffffff;
  font-size: 13.5px;
  font-weight: 600;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.5px;

  &:disabled {
    background-color: #E4E4E4;
    cursor: not-allowed;
    color: #CACACA;
  }
`;

export const TituloModalContainer = styled.div`
  margin-top: -20px;
`;

export const BotonSiguiente = styled.button`
  width: 100%;
  height: 45px;
  background-color:rgb(255, 255, 255);
  text-align: center;
  color: #377CAC;
  font-size: 13.5px;
  font-weight: 600;
  border: 1px solid #377CAC;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.5px;
`;

export const ContainerModalTarjetaInactiva = styled.div`
  background: #fff;
  border-radius: 3px;
  width: 339.4px;
  max-height: 445px;
  padding: 26px 13px;
  position: fixed;
  // top: 10px;
  // left: 30px;
`;

export const TituloModalTarjetaInactiva = styled.h2`
  font-size: 15px;
  text-align: center;
  font-weight: 700;
  line-height: 1.5;
  width: 285px;
  color: #000;
  height: 46px;
  font-family: 'Poppins', sans-serif;
`;

export const BotonTarjetaInactiva = styled.button`
  width: 100%;
  height: 46px;
  background-color:  #377CAC;
;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;
